@if (corporateTaxEntity$ | async) {
  <form [formGroup]="aandeelhoudersFg">
    <div formArrayName="aandeelhouders">
      @for (item of aandeelhouders.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="row mb-0.5">
            <div class="col-auto">
              <snelstart-ui-text-form-control
                [label]="i === 0 ? 'Naam aandeelhouder' : ''"
                class="custom-input-250"
                formControlName="naamAandeelhouder"
                id="naamAandeelhouder"
              >
              </snelstart-ui-text-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-bsn-form-control
                [label]="i === 0 ? 'Fiscaal nummer' : ''"
                class="custom-input-150"
                formControlName="bsnNatuurlijkPersoon"
                id="bsn"
              >
              </snelstart-ui-bsn-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-number-form-control
                [decimals]="2"
                [label]="i === 0 ? 'Percentage aandelen' : ''"
                [showAllDecimals]="true"
                align="right"
                class="custom-input-150"
                formControlName="percentageNominaleKapitaal"
                postfix="%"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-button (click)="showDialog(i)"
                                   [class]="i === 0 ? 'firstrowbutton' : ''"
                                   icon="plus"
                                   type="secondary">Meer gegevens
              </snelstart-ui-button>
            </div>
            <div class="col-auto">
              <snelstart-ui-button
                (click)="verwijderRij(i)"
                [class]="i === 0 ? 'firstrowbutton' : ''"
                icon="trash"
                iconType="light"
                id="buttonDelete"
                size="medium"
                type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="cancel"
                       type="link">Aandeelhouder toevoegen
  </snelstart-ui-button>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="aandeelhoudersGegevens" size="lg" title="Gegevens aandeelhouder">
    <snelstart-ui-dialog-body>
      <div style="max-width: 90%">
        <form [formGroup]="aandeelhoudersFg">
          <div formArrayName="aandeelhouders">
            @for (item of aandeelhouders.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                @if (i === index) {
                  <div formGroupName="adresAandeelhouder">
                      <div class="row">
                          <div class="col col-1">
                              <p>Woon-/vestigingsland {{ aandeelhouders.controls[i].get('naamAandeelhouder')?.getRawValue() }}</p>
                          </div>
                          <div class="col-auto">
                              <snelstart-ui-select-form-control
                                      [options]="optionsLandcodes"
                                      class="custom-input-250"
                                      formControlName="landCode"
                              >
                              </snelstart-ui-select-form-control>
                          </div>
                      </div>
                    <div class="row">
                      <div class="col col-1 pt-1">
                        <p>
                          Adres {{ aandeelhouders.controls[i].get('naamAandeelhouder')?.getRawValue() }}</p>
                      </div>
                      <div class="col-auto">
                        <div class="row">
                          <div class="col-auto">
                            <snelstart-ui-text-form-control
                              class="custom-input-100 ps-1"
                              formControlName="postcode"
                              id="postcode"
                              placeholder="Postcode"
                            >
                            </snelstart-ui-text-form-control>
                          </div>
                          <div class="col-auto">
                            <snelstart-ui-number-form-control
                              [showAllDecimals]="false"
                              class="custom-input-60"
                              formControlName="huisNummer"
                              id="huisNummer"
                              placeholder="Nr."
                            >
                            </snelstart-ui-number-form-control>
                          </div>
                          <div class="col-auto">
                            <snelstart-ui-text-form-control
                              class="custom-input-50"
                              formControlName="huisNummerToevoeging"
                              id="huisNummerToevoeging"
                              placeholder="Tv."
                            >
                            </snelstart-ui-text-form-control>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col col-1">
                      <p>Nominale waarde gewone aandelen</p>
                    </div>
                    <div class="col-auto">
                      <snelstart-ui-number-form-control
                        [showAllDecimals]="false"
                        align="right"
                        class="custom-input-250"
                        formControlName="nominaleWaardeGewoneAandelen"
                        id="nominaleWaardeGewoneAandelen"
                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-1">
                      <p>Nominale waarde preferente aandelen</p>
                    </div>
                    <div class="col-auto">
                      <snelstart-ui-number-form-control
                        [showAllDecimals]="false"
                        align="right"
                        class="custom-input-250"
                        formControlName="nominaleWaardePreferenteAandelen"
                        id="nominaleWaardePreferenteAandelen"
                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-1">
                      <p>Nominale waarde prioriteitsaandelen</p>
                    </div>
                    <div class="col-auto">
                      <snelstart-ui-number-form-control
                        [showAllDecimals]="false"
                        align="right"
                        class="custom-input-250"
                        formControlName="nominaleWaardePrioriteitsAandelen"
                        id="nominaleWaardePrioriteitsAandelen"
                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-1">
                      <p>Dividend betaald aan aandeelhouder</p>
                    </div>
                    <div class="col-auto">
                      <snelstart-ui-number-form-control
                        [showAllDecimals]="false"
                        align="right"
                        class="custom-input-250"
                        formControlName="ontvangenDividend"
                        id="ontvangenDividend"
                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-1">
                      <p>Vordering op aandeelhouder</p>
                    </div>
                    <div class="col-auto">
                      <snelstart-ui-number-form-control
                        [showAllDecimals]="false"
                        align="right"
                        class="custom-input-250"
                        formControlName="vorderingOpAandeelhouder"
                        id="vorderingOpAandeelhouder"
                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>

                  @if (aandeelhouders.controls[i].get('vorderingOpAandeelhouder')?.getRawValue() !== null && aandeelhouders.controls[i].get('vorderingOpAandeelhouder')?.getRawValue() !== 0) {
                    <div class="row">
                      <div class="col col-1">
                        <p>Rente ontvangen van aandeelhouder</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-250"
                          formControlName="ontvangenRenteVanAandeelhouder"
                          id="ontvangenRenteVanAandeelhouder"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>
                  }

                  <div class="row" style="max-width: 800px">
                    <div class="col col-1">
                      <p>Schuld aan aandeelhouder</p>
                    </div>
                    <div class="col-auto">
                      <snelstart-ui-number-form-control
                        [showAllDecimals]="false"
                        align="right"
                        class="custom-input-250"
                        formControlName="schuldAanAandeelhouder"
                        id="schuldAanAandeelhouder"
                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>

                  @if (aandeelhouders.controls[i].get('schuldAanAandeelhouder')?.getRawValue() !== null && aandeelhouders.controls[i].get('schuldAanAandeelhouder')?.getRawValue() !== 0) {
                    <div class="row">
                      <div class="col col-1">
                        <p>Rente betaald aan aandeelhouder</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-250"
                          formControlName="betaaldeRenteAanAandeelhouder"
                          id="betaaldeRenteAanAandeelhouder"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>
                  }
                }
              </div>
            }
          </div>
        </form>
      </div>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
      <snelstart-ui-button class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
      <snelstart-ui-button icon="check" id="save" type="primary">Akkoord</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}

